import { Injectable } from '@angular/core';

@Injectable()
export class ClipboardService {
  copyInputElement(inputElement, tooltip = null): void {
    inputElement.focus();
    inputElement.select();
    document.execCommand('copy');

    if (tooltip) {
      // Manually show clipboard tooltip
      tooltip.open();

      // Hide clipboard tooltip after 1s
      setTimeout(() => {
        tooltip.close();
      }, 1000);
    }
  }
}
